/**
 * ©2018 EdgeVerve Systems Limited (a fully owned Infosys subsidiary),
 * Bangalore, India. All Rights Reserved.
 */
import {
  PolymerElement,
  html
} from "@polymer/polymer/polymer-element.js";
import {
  mixinBehaviors
} from "@polymer/polymer/lib/legacy/class.js";
import '../behaviors/log-out-behaviour.js';
import '../behaviors/mpin-register-behaviour.js';

class mpinDebitCardDetails extends mixinBehaviors([corpBehaviours.logOutBehaviour, corpBehaviours.mpinRegisterBehaviour], PolymerElement) {
  /** Properties definition*/
  static get properties() {
    return {

      selectedPage: {
        type: Number,
        notify: true,
        observer: 'addFocusToDebitCardHeader'
      },
      profilePage: {
        type: Boolean,
        value: false,
        notify: true
      },
      pinLabel: {
        type: String,
        notify: true,
        value: getLabel('l_PIN')
      }
    };
  }
  /** HTML template definition*/


  static get template() {
    return html `
        <style include="corp-app-styles">

				</style>
 
        <app-media-query phone="{{phone}}" desktop="{{desktop}}" tablet="{{tablet}}"></app-media-query>
        <oe-ajax id="logoutAjax" method="post" content-type="application/json" body="{{objData}}" on-response="_handleResponse" on-error="_handleError"></oe-ajax>

                        <div class="brand-background-color mdl-grid">
                          <div class="outlineOffset mdl-cell primary-light-text-l mdl-cell--12-col content-align-center" id="debitCardHeader" tabindex="0">                           
                              <oe-i18n-msg class="" msgid="l_debitCardAuth"></oe-i18n-msg>                      
                          </div>                
                        </div>                       
                        <div class="main-container mdl-cell"
                            wide-layout$="{{wide}}" extra-wide-layout$="{{extra-wide}}">
                            <div phone$="{{phone}}" desktop$="{{desktop}}" tablet$="{{tablet}}" elevation="0">
                            <div class="mdl-cell">
                              <gold-cc-input class="light-text-color-desktop" id="debitcardNumber"  class="full-width" label="{{getLabel('h_DebitCardNumber')}}" value={{maskedAccountId(debitCardNumber,'DBT')}} phone$="{{phone}}" desktop$="{{desktop}}" tablet$="{{tablet}}" ></gold-cc-input>
                            </div>
                            <div class="mdl-grid padding-b-zero"></div>
                            <div class="mdl-cell">
                            <oe-input id="debitCardName" label="l_Name" value="{{name}}"</oe-input>
                            </div>
                            <div class="mdl-grid padding-b-zero"></div>
                            <div class="mdl-cell">
                            <paper-password-input id="loginnewPass" required="required" label="{{pinLabel}}" value={{debitPin}}
                            error-message="{{enterPwd}}" oncopy="return false" onpaste="return false" auto-validate></paper-password-input>
                            </div>
                            <div class="mdl-grid"></div>
                    <div class="mdl-grid"></div><div class="mdl-grid"></div>
                    <div class="mdl-grid"></div><div class="mdl-grid"></div>
                    <div class="mdl-grid"></div>
                    <div class="mdl-grid"></div>
                    <div class="mdl-grid"></div><div class="mdl-grid"></div>
                    <div class="mdl-grid"></div><div class="mdl-grid"></div>
                    <div class="mdl-grid"></div><div class="mdl-grid"></div>
                    <div class="mdl-grid"></div>
                    <div class="mdl-grid"></div>
                            <div class="full-width">
                                <div class="mdl-grid"></div>
                                <div class="mdl-grid mdl-cell mdl-cell--12-col  full-width">
                                    <paper-button id="cancelFromDebit" class="secondary-button" on-tap="cancelPage" raised>
                                        <oe-i18n-msg class="" msgid="b_Cancel"></oe-i18n-msg>
                                    </paper-button>
                                    <paper-button raised class="primary-button" on-tap="gotoNextPage">
                                        <oe-i18n-msg id="quesProceed" msgid="b_Continue"></oe-i18n-msg>
                                    </paper-button>
                                </div>
                            </div>
                          </div>
                      
                    <div class="mdl-grid"></div>
                    <div class="mdl-grid"></div>
                    
             
        `;
  }

  cancelPage() {
    if (!this.profilePage) this.goToLoginPage();
    else {
      this.backToMyProfile();
    }
  }
  gotoNextPage() {
    if (!this.debitCardNumber) {
      this.fire("oe-show-error", getLabel('m_validDebitCardNumber'));
    } else if (this.debitCardNumber && this.debitCardNumber.length != 19) {
      this.fire("oe-show-error", getLabel('m_validDebitCardNumber'));
    } else if (!this.name) {
      this.fire("oe-show-error", getLabel('l_EnterName'));
    } else if (!this.debitPin) {
      this.fire("oe-show-error", getLabel('m_enterDebitCardNumberPin'));
    } else {
      if (this.mpinAuthList && this.mpinAuthList.authenticationDetails && this.mpinAuthList.authenticationDetails.debitCardDetails) this.authorizationDetailsBody.debitCardDetails = {
        debitCardNumber: this.debitCardNumber.replace(/\s/g, ''),
        debitCardAtmPin: this.debitPin,
        debitCardName: this.name
      };
      this.enabledAuthList.shift();
      if (this.enabledAuthList.length > 0) this.selectedPage = this.authPage[this.enabledAuthList[0]];
      else this.postRequest();
    }
  }

  maskedAccountId(accountId, codeType) {
    return maskAccount.accountFormat(accountId, codeType);
  }

  addFocusToDebitCardHeader() {
    if (this.selectedPage == 3) {
      // this.$.SignOnHeader.focus();
      this.$$("#debitCardHeader").focus();
    }
  }
}
customElements.define('mpin-debit-card-details', mpinDebitCardDetails);